<template>
  <div style="padding-left: 20px">
    <p><h3>Impossibile accedere alla risorsa specificata (Non Autorizzato)</h3></p>
    <p>Se è necessario accedere alla risorsa selezionata contatta il Service Desk Applicativo.</p>
  </div>
</template>
<script>
export default {
  
created() {    
  this.$store.commit("SET_showHeader", false);
}

}
</script>